import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export const MetaPixel = () => {
  useEffect(() => {
    const pixelId = '26257470350562748';
    // Avoid double-init
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    // Initialize the fbq queue manually (no DOM dependency)
    const fbq: any = function (...args: any[]) {
      // @ts-ignore
      fbq.callMethod ?
      // @ts-ignore
      fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    // Inject the fbevents.js script safely into <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const head = document.head || document.getElementsByTagName('head')[0];
    if (head) {
      head.appendChild(script);
    } else {
      document.documentElement.appendChild(script);
    }
    // Fire init + PageView
    try {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    } catch (e) {
      // no-op
    }
  }, []);
  return null;
};